const styles = () => ({
  root: {
    margin: 'auto auto',
    maxWidth: 660,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    marginBottom: 40,
  },
  heading: {
    fontWeight: 600,
    marginBottom: 5,
  },
  headingX: {
    fontWeight: 400,
  },
  paragraph: {
    color: '#596168',
    textAlign: 'center',
    margin: '8px 0',
    maxWidth: '80%',
  },
  accounts: {
    marginTop: 20,
    minWidth: 440,
    border: '1px solid rgba(155,173,188,0.20)',
    borderRadius: 6,
    color: '#596168',
    textAlign: 'center',
  },
  account: {
    height: 68,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '10px 20px',
    borderBottom: '1px solid #E1E9F0',
    '&:first-of-type': {
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
    },
    '&:last-of-type': {
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      borderBottom: 'none',
    },
  },
  actions: {
    marginLeft: 'auto',
    paddingLeft: 40,
  },
  avatar: {
    width: 48,
    height: 48,
    marginRight: 10,
  },
  noAccess: {
    color: '#9BADBC',
  },
  currentIndicator: {
    background: '#9BADBC',
    borderRadius: 8,
    fontSize: 12,
    color: 'white',
    margin: '0 10px',
    padding: '0px 8px',
    fontWeight: 500,
  },
  switchMessage: {
    paddingTop: 2,
    paddingBottom: 2,
  },
});

export default styles;
